import { Box } from '@mui/material'
import ContextCardHeader from './ContextCardHeader'
import ContextCardInner from './ContextCardInner'
import styles from './contextCard.module.scss'
import shades from './contextCardShades.module.scss'

const MEDIUM = new Set(['automation', 'artifact'])

export default function ContextCard({ activity = 'connect', title, plain, medium, children }) {
  const shade = shades[activity] ?? shades.connect
  return (
    <Box className={`${styles.shell} ${shade}`}>
      <ContextCardHeader title={title} medium={medium ?? MEDIUM.has(activity)} />
      <ContextCardInner plain={plain}>{children}</ContextCardInner>
    </Box>
  )
}
